import { MetricDescriptor } from "Api/metricsExplorer/types";

export const filterSupportedMetricDescriptors = (
  descriptors: readonly MetricDescriptor[]
): readonly MetricDescriptor[] => {
  const filtered = descriptors.filter(
    d => d.type === "gauge" || d.type === "counter"
  );
  return filtered.length === descriptors.length ? descriptors : filtered;
};
